import FilterOption from "@/features/sub-families/components/filter-option.tsx";
import useMountingKits from "@/features/sub-families/hooks/use-mounting-kits.ts";
import { FilterType, type PropertyConfigCode } from "@/features/sub-families/types";
import { createFilterOption } from "@/features/sub-families/utils/filters.ts";
import { type Nullish, SmartNumberDescriptor, type SmartNumberDescriptorKey } from "@/types";

type ChangeValue = { descriptor: SmartNumberDescriptorKey; configCode: PropertyConfigCode };
type Props = {
    selectedLabel: Nullish<string>;
    onChange: (value: ChangeValue) => void;
    idx: number;
};
export default function MountingKitsFilter({ selectedLabel, onChange, idx }: Props) {
    const choices = useMountingKits();
    if (!choices) return null;

    const config = createFilterOption({
        label: "mounting_kit",
        filterType: FilterType.Radio,
        descriptor: SmartNumberDescriptor.MountingKit,
        choices,
    });

    return (
        <FilterOption
            productProperty="ceiling_meta_data"
            config={config}
            selectedLabel={selectedLabel}
            onChange={onChange}
            idx={idx}
            isDesign
        />
    );
}
